
import { Vue, Component, Watch, Model, Prop } from "vue-property-decorator";
import { AmAutocomplete } from "@afe/amui/src/components/Autocomplete";
import { errorText } from "./errorText";

@Component({
  inheritAttrs: false,
  components: {
    AmAutocomplete
  }
})
export default class extends Vue {
  errorText = "";
  @Model("model") readonly value?: string;
  @Prop(Object) readonly messages!: Record<string, string>;
  @Prop(Object) readonly validator?: object;

  @Watch("validator", { deep: true })
  onError(validator: any) {
    this.errorText = errorText(validator, this.messages);
  }
}
